import React from "react";
import { Input, Form, Radio, Space } from "antd";
import { getLangList } from '@/lib/i18n';
import { currentTime, dateFormat } from "@/lib/dateTime";
import { ReButton } from '@/components/refineElement';
import { modalFromLayout } from "@/lib/antdElementFunction";

interface props {
  form?: any;
  handleType: string;
  rentAndReturnItem: any;
}

class ModalRent extends React.Component<props> {
  rentT: any = getLangList("rent");
  inputRef: any = React.createRef();

  componentDidMount() {
    setTimeout(() => { this.inputRef.current.focus(); }, 100);
  }

  render() {
    const { form, handleType, rentAndReturnItem } = this.props;

    return (
      <Form
        className="admin-form"
        style={{ marginTop: 20 }}
        {...modalFromLayout}
        form={form}
        onFinish={rentAndReturnItem}
        initialValues={{
          date: currentTime.format(dateFormat),
          rentBy: 'accessCardNumber',
        }}
      >
        <Form.Item label={this.rentT.DATE} name="date">
          <Input bordered={false} disabled className="rent-disabled-input" />
        </Form.Item>

        <Form.Item name="rentBy" label={this.rentT.RENT_BY} rules={[{ required: true }]}>
          <Radio.Group onChange={() => this.inputRef.current.focus()}>
            <Space>
              <Radio value='accessCardNumber'>{this.rentT.ACCESS_CARD_NUMBER}</Radio>
              <Radio value='username'>{this.rentT.STUDENT_ID_PLACEHOLDER}</Radio>
            </Space>
          </Radio.Group>
        </Form.Item>

        <Form.Item
          label={handleType === 'rent' ? this.rentT.RENT_PERSON : this.rentT.RETURN_PERSON}
          name="lessee"
          rules={[{ required: true }]}
        >
          <Input ref={this.inputRef} placeholder={`${this.rentT.ACCESS_CARD_NUMBER}、${this.rentT.STUDENT_ID_PLACEHOLDER}`} />
        </Form.Item>

        <Form.Item style={{ display: 'none' }}>
          <ReButton attributeObject={{ htmlType: 'submit' }} />
        </Form.Item>
      </Form >
    );
  }
}

export default ModalRent;